import {
  app
} from './appPixi.js'
import {
  ballStoppedAtTarget
} from './gameManager.js'
import * as UI from './gameUI.js'
import {
  settings
} from './settings.js'
import { playSpinSound } from './soundManager.js'

// const gameValues = {
//   ...UI.gameInitialValues
// }

// const appHeight = app.screen.height
// const appWidth = app.screen.width

const keys = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36
]
const values = [120, 343, 178, 100, 160, 305, 217, 61, 275, 23, 295, 255, 80, 237, 4, 140, 325, 198, 43,
  150, 353, 167, 33, 285, 315, 187, 110, 226, 70, 53, 265, 11, 130, 333, 208, 90, 247
]
const obj = {}

for (let i = 0; i < keys.length; i++) {
  obj[keys[i]] = values[i]
}

const normalizeAngle = (angle) => ((Math.round(angle) % 360) + 360) % 360

/** True when current is in (target - beforeDeg, target + afterDeg), wrapping at 0/360. */
const isAngleInWindow = (current, target, beforeDeg, afterDeg) => {
  const c = normalizeAngle(current)
  const start = normalizeAngle(target - beforeDeg)
  const end = normalizeAngle(target + afterDeg)
  if (start <= end) {
    return c > start && c < end
  }
  return c > start || c < end
}

const circularDistance = (from, to) => {
  const diff = Math.abs(normalizeAngle(from) - normalizeAngle(to))
  return Math.min(diff, 360 - diff)
}

let ballSpeed = settings.rouletteBallSpeed
let rouletteSpeed = settings.rouletteWheelSpeed
let boolToStop = false
let boolStopped = false
let boolBounce = false

let netCal = 1

let targetNumber = 0

let bounceHeight = 5
let MAXbounceHeight = 5

let boolInstantBet = false
let boolAnimation = false
let forceStopTimer = null

const clearForceStopTimer = () => {
  if (forceStopTimer) {
    clearTimeout(forceStopTimer)
    forceStopTimer = null
  }
}

function startGame () {
  clearForceStopTimer()
  playSpinSound()
  ballSpeed = boolInstantBet ? 0 : 8
  UI.gameAssets.rouletteWheel.Ball.visible = !boolInstantBet
}

function stopGame (n) {
  boolToStop = true
  const parsed = Number(n)
  targetNumber = (Number.isFinite(parsed) && parsed >= 0 && parsed <= 36 && obj[parsed] !== undefined)
    ? parsed
    : 0
  clearForceStopTimer()
  forceStopTimer = setTimeout(() => {
    if (!boolStopped) {
      ballSpeed = 0
      UI.containers.rouletteBallContainer.angle = normalizeAngle(obj[targetNumber])
      UI.gameAssets.rouletteWheel.Ball.x = 72
      UI.gameAssets.rouletteWheel.Ball.visible = true
      BallStopped()
    }
  }, 9000)

  if (boolInstantBet) {
    UI.containers.rouletteBallContainer.angle = normalizeAngle(obj[targetNumber])
    UI.gameAssets.rouletteWheel.Ball.x = 72
    UI.gameAssets.rouletteWheel.Ball.visible = true

    BallStopped()
  }
}

function setValuesToInitial () {
  clearForceStopTimer()
  boolToStop = false
  boolStopped = false
  ballSpeed = (boolInstantBet || !boolAnimation) ? 0 : 0.8
  boolBounce = false
  UI.gameAssets.rouletteWheel.Ball.x = 150
  bounceHeight = 5
  MAXbounceHeight = 5
  UI.gameAssets.rouletteWheel.Ball.visible = false
}

function setAnimation (bool) {
  console.log('setAnimation= ', bool)
  if (!bool) {
    rouletteSpeed = 0
    ballSpeed = 0
    boolAnimation = false
  } else {
    rouletteSpeed = settings.rouletteWheelSpeed
    ballSpeed = settings.rouletteWheelSpeed
    boolAnimation = true
  }
}

function setInstantBet (bool) {
  if (bool) {
    boolInstantBet = true
  } else {
    boolInstantBet = false
  }
}

function BallStopped () {
  clearForceStopTimer()
  boolStopped = true
  ballStoppedAtTarget()
}

app.ticker.add((delta) => {
  // if (dddx > 0) {
  //     UI.gameAssets.ball.y = appHeight / 2

  //     if (UI.gameAssets.ball.x <= 10) {
  //         dddx -= dddx * 0.1
  //         ddx = dddx
  //     }

  //     ddx -= .5;
  //     UI.gameAssets.ball.x += ddx
  // }
  //= ======================================================Method 1 ==============================================================
  // if (boolToStop) {
  //     if (Math.round(UI.containers.rouletteBallContainer.angle % 360) >= obj[targetNumber] - 1 &&
  //         Math.round(UI.containers.rouletteBallContainer.angle % 360) <= obj[targetNumber] + 3) {
  //         ballSpeed = 0;
  //     }
  // }

  //  console.log(Math.round(UI.containers.rouletteBallContainer.angle % 360));

  // if (boolToStop) {

  //     if (!boolStopped && ballSpeed > 50 && UI.gameAssets.ball.x > 125) {
  //         ballSpeed -= ballSpeed * 0.05;
  //         UI.gameAssets.ball.x -= 0.4;
  //     } else if (!boolStopped && ((obj[targetNumber] + 175) % 360) < Math.round(UI.containers.rouletteBallContainer.angle % 360) &&
  //         ((obj[targetNumber] + 185) % 360) > Math.round(UI.containers.rouletteBallContainer.angle % 360)) {
  //         if (ballSpeed < 40 && ballSpeed > 30) {
  //             ballSpeed -= ballSpeed * 0.15;
  //             UI.gameAssets.ball.x -= UI.gameAssets.ball.x * 0.8;
  //         }
  //     } else if (!boolStopped && ((obj[targetNumber] + 265) % 360) < Math.round(UI.containers.rouletteBallContainer.angle % 360) &&
  //         ((obj[targetNumber] + 270) % 360) > Math.round(UI.containers.rouletteBallContainer.angle % 360)) {
  //         if (ballSpeed < 30 && ballSpeed > 10) {
  //             ballSpeed -= ballSpeed * 0.2;
  //             UI.gameAssets.ball.x -= UI.gameAssets.ball.x * 0.8;
  //         }
  //         console.log("Else If 2");
  //     } else if (!boolStopped && ((obj[targetNumber] - 5) % 360) < Math.round(UI.containers.rouletteBallContainer.angle % 360) &&
  //         ((obj[targetNumber]) % 360) > Math.round(UI.containers.rouletteBallContainer.angle % 360)) {
  //         console.log("Else If 3");
  //         if (ballSpeed > 0 && ballSpeed < 10) {
  //             ballSpeed -= ballSpeed * 0.7;
  //         } else {
  //             ballSpeed = 0;
  //             boolStopped = true;
  //         }

  //         if( UI.gameAssets.ball.x >50){
  //            // UI.gameAssets.ball.x -= UI.gameAssets.ball.x * 0.1;
  //         }
  //     }
  // }

  //= ========================Method 2==========================================================================
  if (boolToStop && !boolInstantBet) {
    const ballAngle = UI.containers.rouletteBallContainer.angle
    const targetAngle = obj[targetNumber]

    // Enter stop approach when within ~10° before the target pocket (handles wrap at 0°)
    if (!boolStopped && isAngleInWindow(ballAngle, targetAngle, 10, 0)) {
      boolStopped = true
    }

    if (boolStopped) {
      if (UI.gameAssets.rouletteWheel.Ball.x > 105 && !boolBounce) {
        UI.gameAssets.rouletteWheel.Ball.x = 107
      } else {
        boolBounce = true
      }
      if (netCal > 0) {
        netCal = 1 - circularDistance(ballAngle, targetAngle) / 360
      }

      if (ballSpeed > 4) {
        ballSpeed -= (ballSpeed * (netCal) * 0.02)
      } else if (ballSpeed < 4) {
        if (isAngleInWindow(ballAngle, targetAngle, 35, -5)) {
          if (ballSpeed > 0.5) {
            ballSpeed -= ballSpeed * 0.09
          }
        } else if (isAngleInWindow(ballAngle, targetAngle, 3, 2)) {
          ballSpeed -= ballSpeed * 0.15
          if (ballSpeed > 0.3) {
            // Snap once we reach or pass the target pocket (circular)
            if (circularDistance(ballAngle, targetAngle) <= 2 ||
              isAngleInWindow(ballAngle, targetAngle, 0, 2)) {
              UI.containers.rouletteBallContainer.angle = normalizeAngle(targetAngle)
              ballSpeed = 0
              BallStopped()
            }
          }
        }
      }

      if (MAXbounceHeight > 0.5) {
        if (boolBounce) {
          if (UI.gameAssets.rouletteWheel.Ball.position.x <= 72) {
            MAXbounceHeight -= MAXbounceHeight * 0.1
            bounceHeight = MAXbounceHeight
          }
          bounceHeight -= 0.3
          UI.gameAssets.rouletteWheel.Ball.position.x += bounceHeight
        }
      }
    }
  }

  UI.containers.rouletteContainer.angle -= rouletteSpeed * delta
  UI.containers.rouletteBallContainer.angle += ballSpeed * delta
})

export {
  startGame,
  setValuesToInitial,
  stopGame,
  setAnimation,
  setInstantBet
}
